import { FC, useState } from "react";
import { useFormContext } from "react-hook-form";
import CustomRadio from "src/pages/DashboardPage/acadia/components/Tests/components/Ui/CustomRadio";

interface IProps {
  test: any;
}

export const TestRegistryItem: FC<IProps> = ({ test }) => {
  const [showQuestions, setShowQuestions] = useState(false);

  const { register, watch, setValue } = useFormContext();

  const selectedTestID = watch("TestID");

  const handleChangeRadio = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue("TestID", e.target.id, { shouldValidate: true });
  };

  return (
    <div className="p-5 bg-[#F3F4F6] mb-[10px] rounded-md flex justify-between w-full ">
      <label className="w-full hover:cursor-pointer">
        <div className="text-black flex items-center gap-[10px] mb-[5px]">
          <CustomRadio {...register(`Tests.${test.Title}`)} id={test.ID?.toString()} onChange={handleChangeRadio} checked={selectedTestID === test.ID?.toString()}>
            {test?.Title}
          </CustomRadio>
        </div>
        <div className="text-[#637381] mb-[5px]">
          <span>{test.Collections?.Title}</span> | <span>{test.QuestionsID?.length} Вопросов</span>
        </div>

        {showQuestions ? test.QuestionsID.map((question: any) => <div className="text-[#637381] mb-[5px]">{question.Title}</div>) : null}
      </label>
      <span
        onClick={() => {
          setShowQuestions(prev => !prev);
        }}
      >
        {!showQuestions ? (
          <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.99961 11.1002C9.77461 11.1002 9.58711 11.0252 9.39961 10.8752L0.774609 2.4002C0.437109 2.0627 0.437109 1.5377 0.774609 1.2002C1.11211 0.862696 1.63711 0.862696 1.97461 1.2002L9.99961 9.03769L18.0246 1.1252C18.3621 0.787695 18.8871 0.787695 19.2246 1.1252C19.5621 1.4627 19.5621 1.9877 19.2246 2.3252L10.5996 10.8002C10.4121 10.9877 10.2246 11.1002 9.99961 11.1002Z"
              fill="#637381"
            />
          </svg>
        ) : (
          <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18.6246 11.0998C18.3996 11.0998 18.2121 11.0248 18.0246 10.8748L9.99961 2.9623L1.97461 10.8373C1.63711 11.1748 1.11211 11.1748 0.774609 10.8373C0.437109 10.4998 0.437109 9.9748 0.774609 9.6373L9.39961 1.1623C9.73711 0.824805 10.2621 0.824805 10.5996 1.1623L19.2246 9.6373C19.5621 9.9748 19.5621 10.4998 19.2246 10.8373C19.0746 10.9873 18.8496 11.0998 18.6246 11.0998Z"
              fill="#637381"
            />
          </svg>
        )}
      </span>
    </div>
  );
};
